import { render, staticRenderFns } from "./advertisedPriceChart.vue?vue&type=template&id=0c8d4a64&scoped=true&"
import script from "./advertisedPriceChart.vue?vue&type=script&lang=js&"
export * from "./advertisedPriceChart.vue?vue&type=script&lang=js&"
import style0 from "./advertisedPriceChart.vue?vue&type=style&index=0&id=0c8d4a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d4a64",
  null
  
)

export default component.exports